import axios from 'axios'

export const queryCommonConfig = function (payload) {
    return axios({
        method: `post`,
        url: `/fn/commonQuery`,
        data: { funcId: 'CONFIG', ...payload }
    })
}
